/* eslint-disable */
export default {
  dialer: 'ダイヤルパッド',
  allCalls: 'すべての通話',
} as const;

// @key: @#@"dialer"@#@ @source: @#@"Dial Pad"@#@
// @key: @#@"allCalls"@#@ @source: @#@"All Calls"@#@
